import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getSolved } from "../../actions/profile";

const ProfileItem = ({
  profile: { college, website, location, social, bio },
  user: { userName, avatar, _id },
  getSolved,
  solved,
  auth,
}) => {
  useEffect(() => {
    getSolved(auth.user._id);
  }, []);

  return (
    <>
      <Link to='/problems' className='btn btn-light p-1 py-2 m-2'>
        Back To Problems
      </Link>
      {auth.isAuthenticated && auth.loading === false && auth.user._id === _id && (
        <Link to='/edit-profile' className='btn btn-light px-4 m-2'>
          <i className='fas fa-user-circle text-primary'></i> Edit Profile
        </Link>
      )}
      <div className='p-2 mx-auto d-flex flex-column align-items-center'>
        <img
          className='my-1'
          src={avatar}
          alt='avatar'
          style={{ borderRadius: "50%" }}
        />
        <h3 className='large'>{userName}</h3>
        <p>{college}</p>
        <p>{location}</p>
        <div className='my-1'>
          {website && (
            <a href={website} target='_blank' rel='noopener noreferrer'>
              <i className='fas fa-globe fa-2x'></i>
            </a>
          )}
          {social && social.youtube && (
            <a href={social.youtube} target='_blank' rel='noopener noreferrer'>
              <i className='fab fa-linkedin fa-2x'></i>
            </a>
          )}
          {social && social.linkedin && (
            <a href={social.linkedin} target='_blank' rel='noopener noreferrer'>
              <i className='fab fa-youtube fa-2x'></i>
            </a>
          )}
          {social && social.github && (
            <a href={social.github} target='_blank' rel='noopener noreferrer'>
              <i className='fab fa-github fa-2x'></i>
            </a>
          )}
        </div>
        {bio && (
          <>
            <h3>{userName.trim().split(" ")[0]}s Bio</h3>
            <p>{bio}</p>
          </>
        )}
      </div>
      <div className='my-2'>Submission Success -{solved.success_ratio} %</div>
      <div className='my-2'>
        Successful Submissions - {solved.questions_solved}
      </div>
    </>
  );
};

ProfileItem.propTypes = {
  profile: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  solved: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  solved: state.profile.solved,
});

export default connect(mapStateToProps, { getSolved })(ProfileItem);
